import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createBasePackage = (params) => {
  return Api(endPoints.createBasePackage, params, requestType.POST);
};

const getAllBasePackages = (params) => {
  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.supplierId) queryParams.append("supplierId", params.supplierId);
  if (params.status) queryParams.append("status", params.status);
  if (params.isVerified) queryParams.append("isVerified", params.isVerified);
  if (params.categoryId) queryParams.append("categoryId", params.categoryId);
  if (params.subCategoryId)
    queryParams.append("subCategoryId", params.subCategoryId);
  if (params.subSubCategoryId)
    queryParams.append("subSubCategoryId", params.subSubCategoryId);
  if (params.solutionType)
    queryParams.append("solutionType", params.solutionType);
  if (params.tags) queryParams.append("tags", params.tags);

  const finalUrl = queryParams.toString()
    ? `${endPoints.getAllBasePackages}?${queryParams.toString()}`
    : `${endPoints.getAllBasePackages}`;
  return Api(finalUrl, null, requestType.GET);
};

const getBasePackageById = (id) => {
  return Api(
    endPoints.getBasePackageById.replace(":id", id),
    null,
    requestType.GET,
  );
};

const getBasePackageBySlug = (slug) => {
  return Api(
    endPoints.getBasePackageBySlug.replace(":slug", slug),
    null,
    requestType.GET,
  );
};

const updateBasePackage = (id, params) => {
  return Api(
    endPoints.updateBasePackage.replace(":id", id),
    params,
    requestType.PUT,
  );
};

const deleteBasePackage = (id) => {
  return Api(
    endPoints.deleteBasePackage.replace(":id", id),
    null,
    requestType.DELETE,
  );
};

const generateBasePackageSpecification = (params) => {
  return Api(
    endPoints.generateBasePackageSpecification,
    params,
    requestType.POST,
  );
};

const exportBasePackages = (query) => {
  const queryParams = new URLSearchParams();
  if (query.supplierId) queryParams.append("supplierId", query.supplierId);
  const finalUrl = queryParams.toString()
    ? `${endPoints.exportBasePackages}?${queryParams.toString()}`
    : `${endPoints.exportBasePackages}`;
  return Api(finalUrl, null, requestType.GET);
};

export {
  createBasePackage,
  getAllBasePackages,
  getBasePackageById,
  getBasePackageBySlug,
  updateBasePackage,
  deleteBasePackage,
  generateBasePackageSpecification,
  exportBasePackages,
};
